'use client';

import { type IDefaultFormBuilderProps } from '@/components/Form/Fields/types';
import type { FormValues } from '@/components/Form/types';
import { FormControl, FormHelperText } from '@/components/field';
import { RichText } from '@/components/richText/RichText';
import { SwdCheckbox } from '@/components/swdCheckbox/SwdCheckbox';
import { SwdFormControlLabel } from '@/components/swdFormControlLabel/SwdFormControlLabel';
import { richtextToString } from '@/helper/RichText';
import { useSettings } from '@/providers/SettingsProvider';
import type { FormMarketingOptInStoryblok } from '@/types/component-types-sb';
import { useFormikContext } from 'formik';
import { type FC } from 'react';

type MarketingOptinFieldProps = FormMarketingOptInStoryblok & IDefaultFormBuilderProps;
const MarketingOptinField: FC<MarketingOptinFieldProps> = (props) => {
  const settings = useSettings();
  const { values, handleChange, handleBlur } = useFormikContext<FormValues>();
  const value = values['marketing_opt_in'];
  const isChecked = !!value && Array.isArray(value) ? value.length > 0 : false;

  const text =
    props.type == 'email' ? settings?.cdc_marketing_optin_text_email_only : settings?.cdc_marketing_optin_text;
  return (
    <>
      <FormControl error={props.isInvalid}>
        <SwdFormControlLabel
          required={props.required}
          error={props.isInvalid}
          control={
            <SwdCheckbox
              onChange={handleChange}
              onBlur={handleBlur}
              {...props.field}
              id="marketing_opt_in"
              checked={isChecked}
              value={richtextToString(text)}
              required={props.required}
              data-testid="form-builder-marketing-opt-in"
            />
          }
          label={<RichText text={text} />}
        />
        {props.isInvalid && props.errorMessage && <FormHelperText>{props.errorMessage}</FormHelperText>}
      </FormControl>
    </>
  );
};

export default MarketingOptinField;
